import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBookAddressComponent } from './search-book-address/search-book-address.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [SearchBookAddressComponent],
  imports: [
    CommonModule,
    FormsModule  
  ],
  exports: [
    SearchBookAddressComponent
  ]
})
export class ComponentsModule { }
